import { render, staticRenderFns } from "./HostBox.vue?vue&type=template&id=33305ea8&"
import script from "./HostBox.vue?vue&type=script&lang=js&"
export * from "./HostBox.vue?vue&type=script&lang=js&"
import style0 from "./HostBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports